import React from 'react';
import WizardDetailModalForm from './wizard_detail_popup';

import $ from 'jquery'

class EntityDetails extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            detailPopUp: null
        };
    }

    /*  Para fechar pop-up  */

    closePopup = () => {
        $(".left-popup").trigger('click');
    }

    showEntityDetailPopUp = () => {
        let row = this.props.entity
        let detailPopUp = (
            <WizardDetailModalForm
                closePopup={() => this.closePopup()}
                listData={row}
                tab={'detail'}
                onlyDetails={this.props.onlyDetails}
                entityContact={this.props.entityContact}
                billobj={this.props.billobj}
            />
        )
        this.setState({
            detailPopUp
        })
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            <div className="innerBox active d-flex align-items-center">
                <span className="d-flex align-items-center cursor-pointer" data-toggle="modal" data-target='#entity-detail-popup' onClick={() => this.showEntityDetailPopUp()}>
                    <div className="display-content" data-toggle="modal" data-target="#left-popup">
                        <p>{!!this.props.titleName ? "Detalhes entidade" : "Dados de entidade"}</p>
                        <div className="circle">
                            <i className="fas fa-eye"></i>
                        </div>
                    </div>
                </span>
                <div className="modal left-popup" id="entity-detail-popup">
                    <div className="modal-dialog modal-sm">
                        {
                            this.state.detailPopUp
                        }
                    </div>
                </div>
            </div>
        )
    }

}

export default EntityDetails;